import { defineMessages } from 'react-intl'

export default defineMessages({
  assistant: {
    id: 'app.containers.Chat.assistant',
    defaultMessage: 'Finazilla-AI',
  },
  clearHistory: {
    id: 'app.containers.Chat.clearHistory',
    defaultMessage: 'Clear history',
  },
  minimize: {
    id: 'app.containers.Chat.minimize',
    defaultMessage: 'Minimize',
  },
  expand: {
    id: 'app.containers.Chat.expand',
    defaultMessage: 'Expand',
  },
  close: {
    id: 'app.containers.Chat.close',
    defaultMessage: 'Close',
  },
  openChat: {
    id: 'app.containers.Chat.openChat',
    defaultMessage: 'Open chat',
  },
  welcomeMessage: {
    id: 'app.containers.Chat.welcomeMessage',
    defaultMessage: 'Welcome! Ask me anything about using Finazilla.',
  },
  aiDisclaimer: {
    id: 'app.containers.Chat.aiDisclaimer',
    defaultMessage:
      'AI-generated responses may contain errors. We are not responsible for any inaccuracies or issues arising from the use of this assistant.',
  },
  sources: {
    id: 'app.containers.Chat.sources',
    defaultMessage: 'Sources:',
  },
  showSources: {
    id: 'app.containers.Chat.showSources',
    defaultMessage: 'Show sources ({count})',
  },
  hideSources: {
    id: 'app.containers.Chat.hideSources',
    defaultMessage: 'Hide sources',
  },
  sendMessage: {
    id: 'app.containers.Chat.sendMessage',
    defaultMessage: 'Send message',
  },
  typeMessage: {
    id: 'app.containers.Chat.typeMessage',
    defaultMessage: 'Type your message...',
  },
  errorSending: {
    id: 'app.containers.Chat.errorSending',
    defaultMessage: 'Error sending message. Please try again.',
  },
  tokenLimitExceeded: {
    id: 'app.containers.Chat.tokenLimitExceeded',
    defaultMessage: 'You have exceeded the weekly token limit.',
  },
  tokenUsage: {
    id: 'app.containers.Chat.tokenUsage',
    defaultMessage: 'Used {usage} / {limit} tokens',
  },
  tokenResetDate: {
    id: 'app.containers.Chat.tokenResetDate',
    defaultMessage: 'Limit resets: {resetDate}',
  },
  tokenCounter: {
    id: 'app.containers.Chat.tokenCounter',
    defaultMessage: 'Tokens: {used} / {limit}',
  },
  suggestedQuestion1: {
    id: 'app.containers.Chat.suggestedQuestion1',
    defaultMessage: 'How do I create a new budget?',
  },
  suggestedQuestion2: {
    id: 'app.containers.Chat.suggestedQuestion2',
    defaultMessage: 'How does the account scheme work?',
  },
  suggestedQuestion3: {
    id: 'app.containers.Chat.suggestedQuestion3',
    defaultMessage: 'How can I view reports?',
  },
  chatUnauthorized: {
    id: 'app.containers.Chat.chatUnauthorized',
    defaultMessage: 'You are not authorized to use the chat service.',
  },
  chatServiceUnavailable: {
    id: 'app.containers.Chat.chatServiceUnavailable',
    defaultMessage:
      'Chat service is currently unavailable. Please try again later.',
  },
  chatTimeout: {
    id: 'app.containers.Chat.chatTimeout',
    defaultMessage:
      'The answer took too long. Try again or ask a narrower question.',
  },
  chatAnswerTruncated: {
    id: 'app.containers.Chat.chatAnswerTruncated',
    defaultMessage: 'The answer was cut off. Try a narrower question.',
  },
  chatForbidden: {
    id: 'app.containers.Chat.chatForbidden',
    defaultMessage: 'You do not have access to this company.',
  },
  chatInvalidInput: {
    id: 'app.containers.Chat.chatInvalidInput',
    defaultMessage: 'The message could not be sent. Please rephrase it.',
  },
  chatConversationNotFound: {
    id: 'app.containers.Chat.chatConversationNotFound',
    defaultMessage:
      'This conversation is no longer available. Start a new one.',
  },
  chatMissingContext: {
    id: 'app.containers.Chat.chatMissingContext',
    defaultMessage: 'Select a company before using the chat.',
  },
  chatNetworkError: {
    id: 'app.containers.Chat.chatNetworkError',
    defaultMessage: 'Connection lost. Check your network and try again.',
  },
  openFullPage: {
    id: 'app.containers.Chat.openFullPage',
    defaultMessage: 'Open full page',
  },
  backToFloating: {
    id: 'app.containers.Chat.backToFloating',
    defaultMessage: 'Minimize to floating window',
  },
  statusFetchingHistory: {
    id: 'app.containers.Chat.status.fetchingHistory',
    defaultMessage: 'Fetching conversation history...',
  },
  statusProcessingMessage: {
    id: 'app.containers.Chat.status.processingMessage',
    defaultMessage: 'Processing message...',
  },
  statusSearchingDocumentation: {
    id: 'app.containers.Chat.status.searchingDocumentation',
    defaultMessage: 'Searching documentation...',
  },
  statusFetchingFinancialData: {
    id: 'app.containers.Chat.status.fetchingFinancialData',
    defaultMessage: 'Fetching financial data...',
  },
  statusFetchingAccountScheme: {
    id: 'app.containers.Chat.status.fetchingAccountScheme',
    defaultMessage: 'Fetching account scheme...',
  },
  statusThinking: {
    id: 'app.containers.Chat.status.thinking',
    defaultMessage: 'Thinking...',
  },
  statusTokenLimitExceeded: {
    id: 'app.containers.Chat.status.tokenLimitExceeded',
    defaultMessage: 'You have exceeded the maximum token limit.',
  },
  conversations: {
    id: 'app.containers.Chat.conversations',
    defaultMessage: 'Conversations',
  },
  newConversation: {
    id: 'app.containers.Chat.newConversation',
    defaultMessage: 'New conversation',
  },
  deleteConversation: {
    id: 'app.containers.Chat.deleteConversation',
    defaultMessage: 'Delete conversation',
  },
  conversationsEmpty: {
    id: 'app.containers.Chat.conversationsEmpty',
    defaultMessage: 'No previous conversations',
  },
  untitledConversation: {
    id: 'app.containers.Chat.untitledConversation',
    defaultMessage: 'New conversation',
  },
  conversationMessages: {
    id: 'app.containers.Chat.conversationMessages',
    defaultMessage: '{count} messages',
  },
})
